import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Badge = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  background: ${({ theme }) => theme.colors.white};
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  gap: 8px;
`;

const StyledText = styled(Text)`
  span {
    color: ${({ theme }) => theme.colors.black};
  }
`;

interface Props {
  selectedCount: number;
  imagesCount: number;
}

const SelectedImagesBadge: FC<Props> = ({ selectedCount, imagesCount }) => {
  return (
    <Badge>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
          fill="#F0AD1C"
        />
        <path
          d="M9.96214 5.38477L6.0134 9.154L4.03906 7.26938"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <StyledText $color="gray" $type="smallBold">
        Selected:{" "}
        <span>
          {selectedCount}/{imagesCount}
        </span>
      </StyledText>
    </Badge>
  );
};

export default SelectedImagesBadge;
